export default __webpack_public_path__ + "static/media/card2.530af026.svg";